import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface ChartEmptyStateProps {
  title: string;
  description?: string;
}

export function ChartEmptyState({ title, description }: ChartEmptyStateProps) {
  return (
    <Box
      role="status"
      sx={{
        minHeight: 220,
        display: "grid",
        placeItems: "center",
        textAlign: "center",
        px: 2,
      }}
    >
      <Box>
        <Typography variant="subtitle2" color="text.primary">
          {title}
        </Typography>
        {description != null && (
          <Typography variant="caption" color="text.secondary">
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
